import { useHoverIntent } from '@hooks/useHoverIntent';
import SvgAngleDown from '@img/icons/angle-down.svg';
import * as React from 'react';
import NavigationDropdown from '../NavigationDropdown/NavigationDropdown';
import S from './Navigation.styles';
const Navigation = ({ items }) => {
    const { handleMouseEnter, handleMouseLeave, resetNavigation } = useHoverIntent();
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(S.Nav, { onMouseLeave: resetNavigation },
        React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id, "data-id": item.id, onMouseEnter: (e) => handleMouseEnter(e, item.id, 'nav'), onMouseLeave: (e) => handleMouseLeave(e, item.id, 'nav') },
            React.createElement(S.Link, { href: item.url, target: item.target ?? '_self' },
                item.text,
                !!item.children?.length && React.createElement(SvgAngleDown, null)),
            !!item.children?.length && React.createElement(NavigationDropdown, { items: item.children })))))));
};
export default Navigation;
